// services/formService.ts
import axios from 'axios';
import { BASE_URL, getAxiosConfig } from '../../../../components/interface/Config';
import { apiHandler } from '../../../../services/authService';



const fetchForms = async (patientId: string) => {
  const url        = `${BASE_URL}/resource/form?limit=20&slug=stroke-scale&page=1&searchkey=&order_by=order&dir=1&user_id=${patientId}`;
  const response   = await apiHandler('', 'GET',{}, url);

  if (!response) {
    throw new Error("No response received from the server");
  }

  const data = response.data
  console.log('response', data);
  
  // const response = await fetch(`${BASE_URL}/resource/form?limit=20&slug=stroke-scale&page=1&searchkey=&order_by=order&dir=1&user_id=${patientId}`, {
  //   headers: getAxiosConfig().headers,
  // });
  // const data = await response.json();
  return data.data.forms;
};

const submitAnswers = async ( payload: any) => {

  const url        = `${BASE_URL}/resource/form_submitted_answers`;
  const response   = await apiHandler('', 'POST',payload, url);

  // const response = await axios.post(
  //   `${BASE_URL}/resource/form_submitted_answers`,
  //   payload,
  //   {
  //     headers: getAxiosConfig().headers,
  //   }
  // );
  return response;
};

export { fetchForms, submitAnswers };
